<script setup lang="ts">
import { computed } from "vue";
import { useRenderStore } from "../../stores/renderStore";

const renderStore = useRenderStore();

const props = defineProps(["component"]);

const columnWidthClass = (width: number) => {
    switch (width) {
        case 3:
            return "rd-w-full md:rd-w-1/4";
        case 4:
            return "rd-w-full md:rd-w-1/3";
        case 6:
            return "rd-w-full md:rd-w-1/2";
        case 8:
            return "rd-w-full md:rd-w-2/3";
        case 9:
            return "rd-w-full md:rd-w-3/4";
        case 12:
            return "rd-w-full md:rd-w-full";
        default:
            return "rd-w-full";
    }
}

const getColumnWidthClass = computed(() =>
    columnWidthClass(props.component.customData.columnWidth)
);

const horizontalAlignmentClass = computed(() => {
    switch (props.component.customData.horizontalAlignment) {
        case 'start':
            return 'rd-items-start';
        case 'center':
            return 'rd-items-center';
        case 'end':
            return 'rd-items-end';
        default:
            return '';
    }
});

const verticalAlignmentClass = computed(() =>
    props.component.customData.verticalAlignment
        ? `rd-justify-${props.component.customData.verticalAlignment}`
        : ""
);

const columnDisplay = computed(() => (props.component.customData.verticalAlignment ? "rd-flex" : ""));

const flexColumn = computed(() => (props.component.components.length > 1 ? "rd-flex-col" : ""));

const fullWidthImage = computed(() => ((props.component.components.length === 1 && props.component.components[0].type == 'image-component'
    && props.component.components[0].styles.fullWidth) && 'rd-px-0'));
</script>

<template>
    <template v-if="renderStore.hasOneSectionAndIsModalEmbed">
        <slot name="children"></slot>
    </template>

    <template v-else>
        <div class="layout-col rd-relative" :class="[
            component.styles.cssClass,
            getColumnWidthClass,
            horizontalAlignmentClass,
            verticalAlignmentClass,
            columnDisplay,
            flexColumn,
            fullWidthImage]">

            <slot name="controls"></slot>
            <slot name="children"></slot>
        </div>
    </template>
</template>
